<template>
    <div class="flex w-full justify-between">
        <div class="flex w-full gap-x-[12px]">
            <primary-button
                v-for="button in buttons"
                :key="button.value"
                :is-active="button.selected"
                :disabled="loadedFromRecipe"
                @click="selectType(button)"
            >
                {{ button.text }}
            </primary-button>
        </div>
    </div>
</template>

<script>
    import PrimaryButton from './PrimaryButton.vue';

    import allStores from '../../../stores/all';

    export default {
        mixins: [allStores],

        setup() {
            return {
            };
        },

        components: {
            PrimaryButton,
        },

        data() {
            return {
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            loadedFromRecipe() {
                return this.customizerStore.loadedFromRecipe;
            },

            buttons() {
                if (this.viewController == null) {
                    return [];
                }

                const typePlacement = this.viewController.findPlacement('ProductColor');
                const options = this.viewController.groupByDefinitions(typePlacement);
                const placement = options.find((x) => x.description.definition === 'Product Component');

                if (placement == null) {
                    return [];
                }

                const list = [];

                for (const type of placement.options) {
                    if (type.allowed && type.available) {
                        list.push({
                            text: type.option.name,
                            definition: type.option.definition,
                            value: type.option.code,
                            selected: type.selected,
                            safeSelection: type.safeSelection,
                        });
                    }
                }

                return list;
            },
        },

        methods: {
            selectType(type) {
                if (!this.viewController.updateSimilarComponent('ProductColor', type.definition, type.value)) {
                    this.viewController.updateComponent('ProductColor', type.safeSelection);
                }
                // // Manually find a component with the same color and type.
                // const colors = this.viewController?.findPlacement('ProductColor');
                // const selected = this.viewController.selectedAtPlacement('ProductColor');
                // const selectedColor = selected.description.find((x) => x.definition === 'Item Color');

                // for (const color of colors.components) {
                //     if (color.description.some((x) => x.code === type.value)) {
                //         if (color.description.some((x) => x.name === selectedColor.name)) {
                //             if (this.viewController.updateComponent('ProductColor', color.code)) {
                //                 return;
                //             }
                //         }
                //     }
                // }

                // if (type.safeSelection) {
                //     this.viewController.updateComponent('ProductColor', type.safeSelection);
                // }
            },
        },
    };
</script>
